import { PaginatedItin } from './../../shared/models/paginated-itin.model';

import { AnyAction } from 'redux';
import { IItinState, ITIN_STATE, IItin } from './itinerari.model';
import { ItinActionService } from './itinerari.action';

export function itinReducer(state: IItinState =  ITIN_STATE, action: AnyAction): IItinState {

    function orderArray(array_to_order): Array<IItin> {
      return array_to_order.sort((a, b) => {
        if (a.views > b.views) {
          return -1;
        }
        if (a.views < b.views) {
          return 1;
        }
        return 0;
      });
    }

    function checker(src_array, language, target): boolean {
      const supp_array = src_array.map(({name}) => name[language]);
      return target.every(v => supp_array.includes(v));
    }

    switch (action.type) {

        case ItinActionService.PAGINATED_ITIN_LIST:
          const paginatedItin: PaginatedItin = action.payload;
          return {
            ...state,
            list: paginatedItin.list,
            filtered: paginatedItin.list,
            ordered: paginatedItin.list,
            total: paginatedItin.total,
            size: paginatedItin.size,
            page: paginatedItin.page
          };

        case ItinActionService.ITIN_LIST:
          const ordered_list = orderArray([...action.payload]);
          return {
            ...state,
              list: action.payload,
              filtered: action.payload,
              ordered: ordered_list
          };

        case ItinActionService.SET_ITIN_CURRENT:
            return {
              ...state,
                current: action.payload
            };

        case ItinActionService.ADD_OR_UPDATE_ITIN:
          if (state.list.length !== 0) {
            const updateListIdx = state.list.findIndex(({id}) => id === action.payload.id);
            const updateFilteredIdx = state.filtered.findIndex(({id}) => id === action.payload.id);
            let addOrUpdateItinList = [];
            let addOrUpdateItinFilteredList = [];
            if (updateListIdx > -1) {
              addOrUpdateItinList = state.list.map((elem) => {
                if (action.payload.id === elem.id) {
                  return action.payload;
                } else {
                  return elem;
                }
              });
            } else {
              addOrUpdateItinList = [...state.list, action.payload];
            }
            if (updateFilteredIdx > -1) {
              addOrUpdateItinFilteredList = state.filtered.map((elem) => {
                if (action.payload.id === elem.id) {
                  return action.payload;
                } else {
                  return elem;
                }
              });
            } else {
              addOrUpdateItinFilteredList = [...state.filtered];
            }
            const addOrUpdateItinOrderedList = orderArray(addOrUpdateItinList);
            return {
              ...state,
              list: [...addOrUpdateItinList],
              filtered: [...addOrUpdateItinFilteredList],
              ordered: [...addOrUpdateItinOrderedList]
            };
          } else {
            return { ...state };
          }

        case ItinActionService.DELETE_ITIN:
          const listWODeleted = state.list.filter(poi => poi.id !== action.payload);
          const filteredWODeleted = state.filtered.filter(poi => poi.id !== action.payload);
          const orderedWODeleted = state.ordered.filter(poi => poi.id !== action.payload);
          return {
            ...state,
            list: listWODeleted,
            filtered: filteredWODeleted,
            ordered: orderedWODeleted
          };

        case ItinActionService.RESET_FILTERS:
          return {
            ...state,
            filtered: [...state.list],
          };

        case ItinActionService.SEARCH_ITIN:
          const search_filter = action.payload[0];
          const theme_filter = action.payload[1];
          const geopos_filter = action.payload[2];
          const language_filter = action.payload[3];
          const filtered_list = [...state.list].filter(itin =>
            (itin.itin_name[language_filter].toLowerCase().includes(search_filter.toLowerCase()) &&
            (checker(itin.themes, language_filter, theme_filter)) &&
            (checker(itin.geopos, language_filter, geopos_filter)))
          );
          return {
            ...state,
            filtered: [...filtered_list]
          };

        case ItinActionService.TOGGLE_PANEL:
          const toggle_panel_list = [...state.filtered].map(itin => {if (itin.id === action.payload) {
                                                                      itin.expanded_panel = !(itin.expanded_panel);
                                                                    }
                                                                   return itin;
                                                                });
          return {
            ...state,
            filtered: [...toggle_panel_list]
          };

    }

    return state;
}
